import script from "./WapRtoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapRtoView.vue?vue&type=script&lang=ts&setup=true"

import "./WapRtoView.vue?vue&type=style&index=0&id=6325f964&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6325f964"]])

export default __exports__